import { RoomExtra } from 'shared-types/Room';
import React, { FC } from 'react';

type ExtrasCategoryTitleProps = {
  extras: RoomExtra[];
  index: number;
};

export const ExtrasCategoryTitle: FC<ExtrasCategoryTitleProps> = ({ extras, index }) =>
  extras[index]?.category?.name !== extras[index - 1]?.category?.name ? (
    <h3>{extras[index]?.category?.name}</h3>
  ) : null;
